<template>
	<i v-if="isshow"></i>
<!-- <div :class="{'fl':seat!='top','fr':seat=='top','yellorfont':true,'videoLink':true,}" v-if="isshow && curWebsite.type!=4" >
	<a :href="hrefs" target="_blank">{{name}}</a>  
</div> -->
</template>

<script>
	/**产业招商模块操作说明https://share.plvideo.cn/front/video/preview?vid=44796099a495a539ad27fc6ec31ca484_4
	招商算法逻辑讲解https://share.plvideo.cn/front/video/preview?vid=44796099a4978d28472b9b68a01292c8_4
	产业研究模块操作说明https://share.plvideo.cn/front/video/preview?vid=44796099a4e724b14d375f97a8264681_4
	智能推荐模块操作说明https://share.plvideo.cn/front/video/preview?vid=44796099a4a937c7076fddf210d48869_4
	城市监测模块操作说明https://share.plvideo.cn/front/video/preview?vid=44796099a4b71041bc9e194c6e36ec5c_4
	工作台模块操作说明https://share.plvideo.cn/front/video/preview?vid=44796099a4b71041bc9e194c6e36ec5c_4
	个人中心操作说明https://share.plvideo.cn/front/video/preview?vid=44796099a4b71041bc9e194c6e36ec5c_4**/
	export default {
		name: 'videoteaching',
		props:{
			 type:Number,
				seat:{required: false,default:'',},
		},
		data: function(){
			return{ 
				userdata:{operatList:[]},isshow:false,curWebsite:this.$api.getWebsiteType(), 
				 linkarry:[
					{name:"产业招商模块操作说明",href:"https://share.plvideo.cn/front/video/preview?vid=44796099a495a539ad27fc6ec31ca484_4"},
					{name:"产业研究模块操作说明",href:"https://share.plvideo.cn/front/video/preview?vid=44796099a4e724b14d375f97a8264681_4"},
					{name:"智能推荐模块操作说明",href:"https://share.plvideo.cn/front/video/preview?vid=44796099a4a937c7076fddf210d48869_4"},
					{name:"城市监测模块操作说明",href:"https://share.plvideo.cn/front/video/preview?vid=44796099a4b71041bc9e194c6e36ec5c_4"},
					{name:"工作台模块操作说明",href:"https://share.plvideo.cn/front/video/preview?vid=44796099a4b71041bc9e194c6e36ec5c_4"}, 
					{name:"个人中心操作说明",href:"https://share.plvideo.cn/front/video/preview?vid=44796099a4b71041bc9e194c6e36ec5c_4"},
					{name:"招商算法逻辑讲解",href:"https://share.plvideo.cn/front/video/preview?vid=44796099a4978d28472b9b68a01292c8_4"},
						
					],name:"",hrefs:"",
			};
		},
		created() {
			 this.userdata=this.getuserinformain(); 
			 // this.isshow=this.userdata.operatList.mkczsm.btn;
		}, 
		mounted() {
		 if(this.type){
				this.name=this.linkarry[this.type-1].name;
				this.hrefs=this.linkarry[this.type-1].href; 
			}
		}
	}
</script>

<style> 
</style>